// import React, { useEffect, useState } from "react";
// import { ShareIcon } from "lucide-react";
// import { FiUser } from "react-icons/fi";
// import { PiGift } from "react-icons/pi";
// import { useNavigate } from "react-router-dom";
// import { toast } from "sonner";
// import { TfiLocationPin } from "react-icons/tfi";

// export const ServiceList = ({ services }) => {
//   const [showAll, setShowAll] = useState(false);

//   // Show only first 2 items unless 'showAll' is true
//   const visibleServices = showAll ? services : services.slice(0, 2);

//   return (
//     <div className="space-y-1">
//       {visibleServices.map((service, index) => (
//         <div key={index} className="text-xs font-medium">
//           {service.name}
//         </div>
//       ))}

//       {services.length > 2 && (
//         <button
//           className="mt-1 text-orange-600 hover:underline text-[10px]"
//           onClick={() => setShowAll(!showAll)}
//         >
//           {showAll ? "See Less" : "See More"}
//         </button>
//       )}
//     </div>
//   );
// };

// const Vendors = () => {
//   const [vendors, setVendors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAllVendors, setShowAllVendors] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     setLoading(true);
//     fetch("https://api.upswap.app/api/vendor/lists/")
//       .then((res) => res.json())
//       .then((data) => {
//         setVendors(data?.vendors || []);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.error("Error fetching vendors:", err);
//         setLoading(false);
//         toast.error("Failed to fetch popular vendors.");
//       });
//   }, []);

//   const displayedVendors = showAllVendors ? vendors : vendors.slice(0, 5);

//   // --- MODIFIED handleShare FUNCTION ---
//   const handleShare = async (e, vendor) => {
//     // Accept the full vendor object
//     e.stopPropagation(); // Prevent the parent card's click event from firing

//     const url = `${window.location.origin}/vendor/${vendor.vendor_id}`; // Construct the shareable URL

//     if (navigator.share) {
//       try {
//         await navigator.share({
//           title: vendor.full_name || "Vendor Profile",
//           text: `Check out ${vendor.full_name}'s profile on Upswap!`,
//           url: url,
//         });
//       } catch (error) {
//         console.error("Error sharing", error);
//         toast.error("Failed to share profile.");
//       }
//     } else {
//       // Fallback to copying to clipboard if Web Share API is not available
//       navigator.clipboard
//         .writeText(url)
//         .then(() => {
//           toast.info("🔗 Vendor profile link copied to clipboard!");
//         })
//         .catch((err) => {
//           toast.error("❌ Failed to copy link.");
//           console.error("Clipboard copy failed:", err);
//         });
//     }
//   };
//   // --- END OF MODIFIED handleShare FUNCTION ---

//   const shouldShowToggleButton = vendors.length > 5;

//   const handleToggleView = () => {
//     setShowAllVendors((prevState) => !prevState);
//   };

//   return (
//     <div className="bg-white">
//       <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
//         {/* Section Header */}
//         <div className="flex justify-between items-center mb-8">
//           <div>
//             <h2 className="text-xl md:text-2xl leading-8 md:leading-10 font-bold text-gray-900">
//               Popular Vendors
//             </h2>
//             <p className="text-sm md:text-base leading-6 md:leading-7 text-gray-700">
//               Discover trusted local businesses
//             </p>
//           </div>

//           {/* Toggle button to show all vendors or show less */}
//           {shouldShowToggleButton && (
//             <button
//               onClick={handleToggleView}
//               className="
//                 flex items-center text-base font-semibold text-orange-500
//                 hover:text-orange-600 transition-colors duration-200
//               "
//             >
//               {/* {showAllVendors ? (
//                 <>
//                   Show Less <ArrowLeft className="ml-2 w-4 h-4" />
//                 </>
//               ) : (
//                 <>
//                   View all vendors <ArrowRight className="ml-2 w-4 h-4" />
//                 </>
//               )} */}
//             </button>
//           )}
//         </div>

//         {/* Loader */}
//         {loading ? (
//           <div className="flex justify-center items-center p-10">
//             <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
//           </div>
//         ) : (
//           <>
//             {vendors.length === 0 && (
//               <div className="text-center text-gray-600">
//                 No popular vendors found.
//               </div>
//             )}

//             {/* Vendor Cards Grid */}
//             <div
//               className="
//                 grid gap-4
//                 grid-cols-2 /* ✨ This is the only change you need */
//                 sm:grid-cols-2
//                 md:grid-cols-3
//                 lg:grid-cols-4
//                 xl:grid-cols-5
//                 2xl:grid-cols-5
//               "
//             >
//               {displayedVendors.map((vendor) => (
//                 <div
//                   key={vendor.vendor_id}
//                   className="
//       border border-gray-200 rounded-lg overflow-hidden
//       bg-white shadow-md
//       transition-transform duration-200 hover:scale-[1.01]
//       flex flex-col /* ✨ Add this */
//     "
//                 >
//                   <div className="relative h-32 sm:h-40 md:h-40 overflow-hidden">
//                     <img
//                       src={
//                         vendor.profile_pic ||
//                         "https://placehold.co/400x200/cccccc/ffffff?text=No+Image"
//                       }
//                       alt={vendor.full_name}
//                       className="w-full h-full object-cover rounded-t-lg"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                         e.target.src =
//                           "https://placehold.co/400x200/cccccc/ffffff?text=No+Image";
//                       }}
//                     />
//                   </div>

//                   {/* Make this a flex container that grows */}
//                   <div className="p-3 flex flex-col flex-grow">
//                     {" "}
//                     {/* ✨ Add flex-grow */}
//                     {/* Wrap top content to push buttons down */}
//                     <div className="flex-grow">
//                       <h3 className="font-semibold text-slate-700 text-base leading-tight mb-2 flex items-center gap-1">
//                         <FiUser className="text-base" />
//                         <span>{vendor.full_name}</span>
//                       </h3>

//                       {/* 👇 FIX IS HERE: Add a minimum height class */}
//                       <div className="text-xs text-gray-500 flex items-start gap-2 mb-2 min-h-[2.5rem]">
//                         <PiGift className="text-base flex-shrink-0 mt-0.5" />
//                         {vendor.services?.length ? (
//                           <ServiceList services={vendor.services} />
//                         ) : (
//                           <span>N/A</span>
//                         )}
//                       </div>

//                       <p className="flex items-center text-xs text-gray-500 mb-2">
//                         <TfiLocationPin className="mr-1 h-4 w-4 text-gray-500" />
//                         <span className="font-medium text-gray-700">
//                           {vendor.addresses?.[0]?.road_name_area_colony ||
//                             "N/A"}
//                         </span>
//                       </p>
//                     </div>
//                     {/* This div will now be pushed to the bottom */}
//                     <div className="flex gap-2 justify-between mt-4">
//                       <button
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           navigate(`/vendor/${vendor.vendor_id}`);
//                         }}
//                         className="
//             flex-grow py-1.5 px-3 bg-orange-500 text-white
//             rounded-md font-medium text-sm
//             hover:bg-orange-600 transition-colors duration-200
//             whitespace-nowrap
//           "
//                       >
//                         View Profile
//                       </button>
//                       <button
//                         className="
//             p-1.5 border-gray-300 rounded-md bg-white text-gray-700
//             flex items-center justify-center
//             hover:bg-gray-100 transition-colors duration-200
//           "
//                         onClick={(e) => handleShare(e, vendor)}
//                       >
//                         <ShareIcon className="w-4 h-4" />
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Vendors;

import React, { useEffect, useState } from "react";
import { ShareIcon } from "lucide-react";
import { FiUser } from "react-icons/fi";
import { PiGift } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { TfiLocationPin } from "react-icons/tfi";

// Service list component
export const ServiceList = ({ services }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleServices = showAll ? services : services.slice(0, 2);

  return (
    <div className="space-y-1">
      {visibleServices.map((service, index) => (
        <div key={index} className="text-xs font-medium">
          {service.name}
        </div>
      ))}
      {services.length > 2 && (
        <button
          className="mt-1 text-orange-600 hover:underline text-[10px]"
          onClick={() => setShowAll(!showAll)}
        >
          {showAll ? "See Less" : "See More"}
        </button>
      )}
    </div>
  );
};

const Vendors = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAllVendors, setShowAllVendors] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch vendors
  useEffect(() => {
    setLoading(true);
    fetch("https://api.upswap.app/api/vendor/lists/")
      .then((res) => res.json())
      .then((data) => {
        setVendors(data?.vendors || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching vendors:", err);
        toast.error("Failed to fetch popular vendors.");
        setLoading(false);
      });
  }, []);

  // Handle sharing
  const handleShare = async (e, vendor) => {
    e.stopPropagation();
    const url = `${window.location.origin}/vendor/${vendor.vendor_id}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: vendor.full_name || "Vendor Profile",
          text: `Check out ${vendor.full_name}'s profile on Upswap!`,
          url: url,
        });
      } catch (error) {
        console.error("Error sharing", error);
        toast.error("Failed to share profile.");
      }
    } else {
      navigator.clipboard
        .writeText(url)
        .then(() => toast.info("🔗 Vendor profile link copied to clipboard!"))
        .catch((err) => {
          toast.error("❌ Failed to copy link.");
          console.error("Clipboard copy failed:", err);
        });
    }
  };

  // Set displayed vendors
  const displayedVendors = (() => {
    if (isMobile) return vendors.slice(0, 6);
    return showAllVendors ? vendors : vendors.slice(0, 5);
  })();

  const shouldShowToggleButton = vendors.length > 5 && !isMobile;

  return (
    <div className="bg-white">
      <div className="py-8 px-4 sm:px-6 md:px-8 max-w-screen-2xl mx-auto">
        {/* Section Header */}
        <div className="flex justify-between items-center mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">
              Popular Vendors
            </h2>
            <p className="text-sm md:text-base text-gray-700">
              Discover trusted local businesses
            </p>
          </div>

          {/* Toggle button only for desktop/laptop */}
          {shouldShowToggleButton && (
            <button
              onClick={() => setShowAllVendors((prev) => !prev)}
              className="text-base font-semibold text-orange-500 hover:text-orange-600 transition-colors"
            >
              {showAllVendors ? "View Less" : "View All"}
            </button>
          )}
        </div>

        {/* Loader */}
        {loading ? (
          <div className="flex justify-center items-center p-10">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
          </div>
        ) : vendors.length === 0 ? (
          <div className="text-center text-gray-600">
            No popular vendors found.
          </div>
        ) : (
          <div
            className="grid gap-4
              grid-cols-2 sm:grid-cols-2
              md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-5"
          >
            {displayedVendors.map((vendor) => (
              <div
                key={vendor.vendor_id}
                className="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-md hover:scale-[1.01] transition-transform duration-200 flex flex-col"
              >
                {/* Image */}
                <div className="relative h-32 sm:h-40 md:h-40 overflow-hidden">
                  <img
                    src={
                      vendor.profile_pic ||
                      "https://placehold.co/400x200/cccccc/ffffff?text=No+Image"
                    }
                    alt={vendor.full_name}
                    className="w-full h-full object-cover rounded-t-lg"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://placehold.co/400x200/cccccc/ffffff?text=No+Image";
                    }}
                  />
                </div>

                {/* Content */}
                <div className="p-3 flex flex-col flex-grow">
                  <div className="flex-grow">
                    <h3 className="font-semibold text-slate-700 text-base mb-2 flex items-center gap-1">
                      <FiUser className="text-base" />
                      <span>{vendor.full_name}</span>
                    </h3>

                    <div className="text-xs text-gray-500 flex items-start gap-2 mb-2 min-h-[2.5rem]">
                      <PiGift className="text-base flex-shrink-0 mt-0.5" />
                      {vendor.services?.length ? (
                        <ServiceList services={vendor.services} />
                      ) : (
                        <span>N/A</span>
                      )}
                    </div>

                    <p className="flex items-center text-xs text-gray-500 mb-2">
                      <TfiLocationPin className="mr-1 h-4 w-4 text-gray-500" />
                      <span className="font-medium text-gray-700">
                        {vendor.addresses?.[0]?.road_name_area_colony || "N/A"}
                      </span>
                    </p>
                  </div>

                  <div className="flex gap-2 justify-between mt-4">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/vendor/${vendor.vendor_id}`);
                      }}
                      className="flex-grow py-1.5 px-3 bg-orange-500 text-white rounded-md font-medium text-sm hover:bg-orange-600 transition-colors"
                    >
                      View Profile
                    </button>
                    <button
                      className="p-1.5 bg-white rounded-md text-gray-700 hover:bg-gray-100 transition"
                      onClick={(e) => handleShare(e, vendor)}
                    >
                      <ShareIcon className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Vendors;
